// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"mo-z","imageAndVideoCount":"no-z","imageAndVideoContainer":"oo-z","viewAllReviews":"po-z"};